import Modal from "react-modal";
import "../style/index.css";
import Loading from "../components/loading";
import Button from "../components/ui/button";
import check from "../assets/images/check.svg";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";

const AcceptPaymentModal = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const closeModal = () => {
    props.setshow(false);
  };

  const handleAccept = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");

      const response = await axios.post(
        `/v1/admin/finance/pay/update/status/${id}`,
        {
          status: "approved",
        },
        {
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        }
      );

      if (response.data?.error) {
        const errorData = await response?.data;
        throw new Error(errorData?.message || `HTTP error! status: ${response?.status}`);
      }

      closeModal();
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Payment accepted successfully!",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });

      setTimeout(() => {
        navigate(-1);
      }, 100);
    } catch (error) {
      console.error("Error accepting payment request:", error);
      Swal.fire({
        icon: "error",
        title: "Failed to accept payment",
        text: error?.response?.data?.message || error?.message || "An unexpected error occurred.",
        timer: 4000,
        showConfirmButton: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const customStyles = {
    content: {
      margin: "5% auto",
      overflow: "hidden",
      maxWidth: "400px",
      height: "300px",
      width: "85%",
      padding: "20px",
      borderRadius: "8px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };

  return (
    <Modal
      isOpen={props.show}
      ariaHideApp={false}
      style={customStyles}
      contentLabel="Accept Payment Modal"
      onRequestClose={closeModal}
    >
      <div className="modal-header">
        <button
          type="button"
          className="material-icons close-icon"
          onClick={closeModal}
          aria-label="Close modal"
        >
          close
        </button>
      </div>

      <div className="flex flex-col items-center justify-center modal-content">
        <img src={check} alt="check" className="mb-2" />
        <h3 className="w-[295px] text-[20px] text-[#101828] font-bold text-center mb-4">
          Are you sure you want to accept this payment request?
        </h3>

        <form onSubmit={handleAccept} className="w-full decline-form">
          <Button
            type="submit"
            className="w-full mt-4 p-4 rounded-[10px] bg-[#EBE4FF] font-bold text-[#6F00FF] hover:bg-[#d9d0ff] hover:text-[#6F00FF]"
            disabled={isLoading}
          >
            {isLoading ? <Loading /> : "Accept request"}
          </Button>
        </form>
      </div>
    </Modal>
  );
};

export default AcceptPaymentModal;
